module.exports = __webpack_public_path__ + "static/media/share-purple.1beb1d21.svg";